var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 p-4 border-b border-gray-200"},[_c('ul',{staticClass:"timeline"},_vm._l((_vm.statuses),function(status,i){return _c('li',{key:i,class:{
        current: status == _vm.displayStatus,
        active: status <= _vm.displayStatus
      }},[_c('span',[_vm._v(_vm._s(_vm.$t(("status.short." + status))))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }